<div class="body">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>euro_symbol</mat-icon>
        </button>
        <span>Angebot auswählen</span>
        <span class="spacer"></span>
        <button mat-icon-button color="warn" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <mat-form-field class="width" appearance="fill">

            <mat-label>Angebot suchen</mat-label>
            <input type="text" placeholder='Suchbegriff eingeben' matInput [formControl]="formControl"
                (keyup.enter)="search()" />
            <mat-icon matSuffix>search</mat-icon>

        </mat-form-field>

        <div class="results preview-entry-container" *ngIf="offers.length > 0; else noOffers">

            <div class="preview-entry" *ngFor="let offer of offers" (click)="offerClicked(offer)">
                <app-offer-preview [offer]="offer"></app-offer-preview>
            </div>

            <div class="load-more-wrapper" *ngIf="total > offers.length">

                <button mat-raised-button (click)="loadMore()">
                    Mehr laden
                </button>

            </div>

        </div>

        <div class="footer">

            {{offers.length}} von {{total}}

        </div>

    </div>

</div>

<ng-template #noOffers>

    <div class="no-offers-hint">

        <div class="text">Keine Angebote gefunden</div>

    </div>

</ng-template>
